import { Component, effect, inject, input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { S3Service } from '../../../shared/components/filemanager/services/s3.service';
import { AuthService } from '../../auth/services/authentication.service';

@Component({
  selector: 'app-profile-image',
  template: ` <div
    class="author-image-container"
    style="border: 0px;"
  >
    @if (profileImgSrc) {
      <img
        [src]="profileImgSrc"
        width="100%"
        height="100%"
      />
    }
    @if (!isLoading && !profileImgSrc) {
      <img
        class="animate default-img"
        width="25"
        height="25"
      />
    }
    @if (isLoading) {
      <dx-load-indicator
        class="item-loader"
        height="20"
        width="20"
      ></dx-load-indicator>
    }
  </div>`,
  imports: [DxLoadIndicatorModule],
})
export class ProfileImageComponent implements OnInit, OnDestroy {
  profileImg = input<string | null>();

  public isLoading = false;
  public profileImgSrc?: SafeUrl;
  private subscription?: Subscription;
  private subscriptionAuth?: Subscription;
  private loggedIn = false;

  readonly #authService = inject(AuthService);
  readonly #s3Service = inject(S3Service);
  readonly #sanitizer = inject(DomSanitizer);

  public ngOnInit() {
    this.subscriptionAuth = this.#authService
      .isLoggedIn()
      .pipe(distinctUntilChanged())
      .subscribe((loggedIn) => {
        this.loggedIn = loggedIn;
      });
  }

  constructor() {
    effect(() => {
      const imageKey = this.profileImg();
      if (imageKey) {
        this.isLoading = true;
        this.#s3Service
          .getFileUrl(imageKey)
          .pipe(take(1))
          .subscribe((blob: Blob) => {
            const url = URL.createObjectURL(blob);
            this.profileImgSrc = this.#sanitizer.bypassSecurityTrustUrl(url);
            this.isLoading = false;
          });
      } else {
        this.profileImgSrc = undefined;
        this.isLoading = false;
      }
    });
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.subscriptionAuth?.unsubscribe();
  }
}
